function removeAttr(element: HTMLElement, data: string | string[]): void {
    // If data is string
    if (typeof data === 'string') {
        data = data.split(' ');
    }

    // Foreach Data
    for (const item of data) {
        element.removeAttribute(item);
    }
}

// ----------------------------------------------------------------------------

export default removeAttr;
